// Hover-swap behavior for the custom desktop mega-menu (Shop By Need / Shop By Category),
// ported from the Nutriorg nav mockup. Scoped to .nrgmega-* elements only.
(function () {
  document.querySelectorAll(".nrgmega").forEach(function (mega) {
    var icons = mega.querySelectorAll(".nrgmega__icon-item");
    var panels = mega.querySelectorAll(".nrgmega__dynamic-panel");
    var promoPanels = mega.querySelectorAll(".nrgmega__promo-panel");
    function activate(icon) {
      var target = icon.getAttribute("data-nrgmega-target");
      icons.forEach(function (i) {
        i.classList.toggle("is-active", i === icon);
      });
      panels.forEach(function (p) {
        p.classList.toggle("is-active", p.getAttribute("data-nrgmega-panel") === target);
      });
      promoPanels.forEach(function (p) {
        p.classList.toggle("is-active", p.getAttribute("data-nrgmega-promo-panel") === target);
      });
    }

    icons.forEach(function (icon) {
      icon.addEventListener("mouseenter", function () {
        activate(icon);
      });
    });
  });
})();
